module.exports = __webpack_public_path__ + "static/media/banner_forest_height_data.4e471a7d.jpg";